import { Layout } from 'antd';
import cn from 'classnames';
import * as React from 'react';

import { PropsWithClassName } from 'types/common';

import { BaseHeader } from '../BaseHeader';

import s from './BaseLayout.module.scss';

type BaseLayoutProps = {
  header?: React.ReactNode;
  children?: React.ReactNode;
  contentClassName?: string;
} & PropsWithClassName;

const BaseLayout: React.FC<BaseLayoutProps> = ({
  className,
  header,
  children,
  contentClassName,
}) => {
  return (
    <Layout className={cn(s.layout, className)}>
      {header && <BaseHeader>{header}</BaseHeader>}
      <Layout.Content className={cn(s.layout__content, contentClassName)}>
        {children}
      </Layout.Content>
    </Layout>
  );
};

export default BaseLayout;
